import React from "react";
import { AccountInfo } from "@azure/msal-browser";

interface AuthContextValue {
  login: () => Promise<void>;
  logout: () => Promise<void>;
  activeADAccount: AccountInfo | null;
}

export const AuthContext = React.createContext<AuthContextValue>(null as any);
